import { CONSTS } from 'config/objectConst'

import { api } from '../api'

export type Plan = ReturnType<typeof usePlans>[number]

export function usePlans() {
	const { data, isSuccess } = api.useSubscriptionQuery()

	const isActive = isSuccess && data.is_active
	const id = (isSuccess && data.plan_id) || ''
	const info = CONSTS.SUBSCRIPTIONS

	const isBasic = id === info.BASIC.ID,
		isExperimental = id === info.EXPERIMENTAL.ID,
		isPro = id === info.PRO.ID,
		isTeam = id === info.TEAM.ID

	return [
		{
			active: isActive && (isExperimental || isBasic),
			arrayData: [
				'Connect people',
				'Export & Filter contacts',
				'Send messages',
				'Campaign statistics',
				'Send auto follow ups',
				'Auto withdraw invites',
				'CSV Export contacts',
				'Unlimited campaigns'
			],
			description:
				isExperimental && isActive
					? 'Includes bonus features for early-birds!'
					: 'Your basic snaily that searching for leads',
			id: info.BASIC.ID,
			name:
				isExperimental && isActive ? info.EXPERIMENTAL.NAME : info.BASIC.NAME,
			path: info.BASIC.ID,
			price:
				isExperimental && isActive ? info.EXPERIMENTAL.PRICE : info.BASIC.PRICE
		},
		{
			active: isActive && isPro,
			arrayData: [
				'Basic features',
				'Cloud automation',
				'Sales navigator',
				'Activities log CSV export',
				'Zapier - under construction'
			],
			description: 'For pro hunters that require  extended features',
			id: info.PRO.ID,
			name: info.PRO.NAME,
			path: info.PRO.ID,
			price: info.PRO.PRICE
		},
		{
			active: isActive && isTeam,
			arrayData: ['Pro features', 'Team work'],
			description: 'For teams and companies',
			id: info.TEAM.ID,
			name: info.TEAM.NAME,
			path: info.TEAM.ID,
			price: info.TEAM.PRICE
		}
	]
}
